module.exports = __webpack_public_path__ + "img/6.df34878f.jpeg";